import { DateTime } from "luxon";
import React from "react";

import { OFFSET } from "@src/features/scheduleExperience/constants";
import { ScheduleContent } from "@src/features/scheduleExperience/ScheduleContent";
import { ScheduleProps } from "@src/features/scheduleExperience/types";

export const PauseSchedule = ({
  startAtSchedule,
  experience,
  isLoading,
  setDateTime,
  dateTime,
  timeNow,
  disabledReason,
  isStartSet,
  pauseAtSchedule,
  endAtSchedule,
  currMinDateTime,
  setErrors,
}: ScheduleProps) => {
  return (
    <ScheduleContent
      setErrors={setErrors}
      isStartSet={isStartSet}
      isLoading={isLoading}
      label={experience.category === "personalization" ? "Stop" : "Pause"}
      setDateTime={setDateTime}
      dateTime={dateTime}
      minScheduleTime={
        experience.status === "started"
          ? timeNow
          : currMinDateTime
            ? currMinDateTime.plus({
                minutes: OFFSET,
              })
            : startAtSchedule?.executionTime
              ? DateTime.fromMillis(startAtSchedule.executionTime).plus({
                  minutes: OFFSET + 10,
                })
              : timeNow
      }
      action={"pause"}
      experience={experience}
      disabledReason={disabledReason}
      pauseAtSchedule={pauseAtSchedule}
      endAtSchedule={endAtSchedule}
      timeNow={timeNow}
    />
  );
};
